// src/utils/logEvent.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function logEvent(type, details, admin) {
  try {
    await addDoc(collection(db, "logs"), {
      type, // e.g., "create", "edit", "delete"
      details, // an object with details about the action
      admin, // the UID or email of the admin who performed the action
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error logging event:", error);
  }
}
